// extracted by mini-css-extract-plugin
export default {"TextareaContainer":"TabPane_TextareaContainer__c0Vxj","Handle":"TabPane_Handle__RMcVQ","resizableHandle":"TabPane_resizableHandle__-R+nF"};